



































import {
  Component,
  Vue,
  Prop,
  Watch,
} from 'vue-property-decorator';
import StarRating from '@/components/StarRating.vue';
import {DeviceVersion, MarketingDetails} from '@/types';
import ConfirmButton from '@/components/ConfirmButton.vue';
import MarketingDetailsService from '@/services/marketing.details.service';
@Component({
  components: {
    ConfirmButton,
    StarRating,
  },
})
export default class AdminCatalogueDetails extends Vue {
  @Prop() private deviceType!: DeviceVersion;
  private details: MarketingDetails = {} as MarketingDetails;

  private async mounted() {
    await this.getMarketingDetails();
  }

  private async getMarketingDetails() {
    const deviceVersion = await MarketingDetailsService.getMarketingDetails(this.deviceType.id);
    const details = (deviceVersion as any).marketing_details || {};
    Vue.set(this, 'details', details);
  }

  private async saveMarketingDetails() {
    const details: MarketingDetails = {
      id: this.details.id || undefined,
      device_version_id: this.deviceType.id,
      marketing_text: this.details.marketing_text,
      purchase_link_text: this.details.purchase_link_text,
      purchase_link_url: this.details.purchase_link_url,
      rating: this.details.rating,
      review: this.details.review,
    };

    if (!details.id) {
      await MarketingDetailsService.saveMarketingDetails(details);
    } else {
      await MarketingDetailsService.updateMarketingDetails(details);
    }

    this.$emit('success');

    await this.getMarketingDetails();
  }
}
